import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#activity_report",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "ToT Course Report")
  ])
], -1)
const _hoisted_3 = {
  id: "activity_report",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "position-relative" }
const _hoisted_8 = { class: "collapse show" }
const _hoisted_9 = { class: "card-body p-0 mt-5" }
const _hoisted_10 = { class: "row w-100 mb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 my-auto" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "m-0" }, "ToT Course Report")
], -1)
const _hoisted_12 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid black"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid black"} }, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid black"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "align-middle border border-gray-400"
    }, " Tranche "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "align-middle border border-gray-400"
    }, " Training Partner "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "align-middle border border-gray-400"
    }, " Course Name "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "align-middle border border-gray-400"
    }, " Target "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "align-middle border border-gray-400"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "align-middle border border-gray-400"
    }, " Assessment "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "align-middle border border-gray-400"
    }, " Certified "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "align-middle border border-gray-400"
    }, " Employed ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Female"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Female"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Female"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Female")
  ])
], -1)
const _hoisted_19 = { style: {} }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "3",
  style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"}
}, " Total ", -1)
const _hoisted_24 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_25 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_26 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_27 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_28 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_29 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_30 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_31 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }
const _hoisted_32 = { style: {"border":"1px solid  !important","text-align":"center","font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.showActivityReport == true)
              ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                              title: "Download Xlse",
                              "data-v-54b12dc8": "",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportTrainee()))
                            }, _hoisted_14),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                              title: "Download PDF",
                              "data-v-54b12dc8": "",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadPdf()))
                            }, _hoisted_16)
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("tbody", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.courseData, (data, key) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: key,
                                class: "border border-gray-400 text-center"
                              }, [
                                _createElementVNode("td", null, [
                                  (data?.tranche_id ==1 )
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Tranche-1"))
                                    : _createCommentVNode("", true),
                                  (data?.tranche_id == 2)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, " Tranche-2"))
                                    : _createCommentVNode("", true),
                                  (data?.tranche_id == 5)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Tranche-3"))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(data?.entity_short_name), 1),
                                _createElementVNode("td", null, _toDisplayString(data?.course_name), 1),
                                _createElementVNode("td", null, _toDisplayString(data?.total_target_trainee), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.t_enrolled)), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.f_enrolled)), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.t_assessed)), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.f_assessed)), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                                                        data?.t_certified
                                                                    )), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.f_certified)), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(data?.t_employed)), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.numberWithCommas(
                                                                        data?.f_employed
                                                                    )), 1)
                              ]))
                            }), 128)),
                            _createElementVNode("tr", null, [
                              _hoisted_23,
                              _createElementVNode("th", _hoisted_24, _toDisplayString(Number(
                                              _ctx.TotalTarget
                                          ).toLocaleString()), 1),
                              _createElementVNode("th", _hoisted_25, _toDisplayString(Number(
                                         _ctx.Totalenroll
                                      ).toLocaleString()), 1),
                              _createElementVNode("th", _hoisted_26, _toDisplayString(Number(
                                          _ctx.TotalFemaleEnroll
                                      ).toLocaleString()), 1),
                              _createElementVNode("th", _hoisted_27, _toDisplayString(Number(
                                          _ctx.TotalAssessed
                                      ).toLocaleString()), 1),
                              _createElementVNode("th", _hoisted_28, _toDisplayString(Number(
                                          _ctx.TotalFemaleAssessed
                                      ).toLocaleString()), 1),
                              _createElementVNode("th", _hoisted_29, _toDisplayString(Number(
                                         _ctx.Totalcertified
                                      ).toLocaleString()), 1),
                              _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.TotalFemaleCertified), 1),
                              _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.TotalEmployed), 1),
                              _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.TotalFemaleEmployed), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.loading]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}